import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

export const authenticateAdmin = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

export const logoutAdmin = () => signOut(auth);

export const isAdminLoggedIn = () => auth.currentUser !== null;

export const onAdminAuthStateChanged = (callback) =>
  onAuthStateChanged(auth, callback);
